export const images = [
    {
      id: '01',
      src: '/weber heights 01.jpg',
      alt: 'Lofts on 34th',
    },
    // {
    //   id: '02',
    //   src: '/shulsen-lane-2.jpg',
    //   alt: 'Shulsen Lane',
    // },
    {
      id: '03',
      src: '/weber heights 02.jpg',
      alt: 'Lofts on 34th',
    },
    {
      id: '04',
      src: '/weber heights 03.jpg',
      alt: 'Lofts on 34th',
    },
    
    {
        id: '06',
        src: '/weber heights 04.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/weber heights 05.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/weber heights 06.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/weber heights 07.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/weber heights 08.jpg',
        alt: 'Lofts on 34th',
      },
     
     
    //   {
    //     id: '05',
    //     src: '/DesertSage (5).jpg',
    //     alt: 'Shulsen Lane',
    //   },
    // {
    //   id: '06',
    //   src: '/Alpine_Flats_Theater_Room.jpg',
    //   alt: 'Revive Apartments',
    // },
   
  ]